/* eslint-disable react/jsx-curly-brace-presence */
import React from "react";
import { styled } from "@iventis/styles";
import { differenceInMinutes, format } from "date-fns";
import { fontSizes } from "@iventis/styles/src/atomic-rules";
import { SessionComponent } from "@iventis/calendar/components/types";
import { SportEventUnitComponentProps, SportSessionComponentProps } from "./sport-event-types";

export const SportSessionRenderer: SessionComponent<SportSessionComponentProps> = React.memo(({ session, contrastTextColour }) => (
    <SessionInfo color={contrastTextColour}>
        <Row>
            <SessionCode>{session.name}</SessionCode>
            <SessionTime>
                {format(session.sessionStart, "HH:mm")} - {format(session.sessionEnd, "HH:mm")}
            </SessionTime>
        </Row>
        {session.displayText && (
            <Row>
                <SessionDisplayText>{session.displayText}</SessionDisplayText>
            </Row>
        )}
        {session.description}
    </SessionInfo>
));

export const SportEventUnitRenderer: SessionComponent<SportEventUnitComponentProps> = ({ session, contrastTextColour }) => (
    <SessionInfo color={contrastTextColour}>
        <Row>
            <SessionTime>
                {format(session.sessionStart, "HH:mm")} - {format(session.sessionEnd, "HH:mm")} ({differenceInMinutes(session.sessionEnd, session.sessionStart).toString()}
                {"'"})
            </SessionTime>
        </Row>
        <Row>
            <EventUnitDescription>{session.name}</EventUnitDescription>
        </Row>
    </SessionInfo>
);

const SessionDisplayText = styled.div`
    font-weight: 500;
    padding-right: 12px;
`;

const Row = styled.div`
    display: flex;
    flex-wrap: wrap;
    padding-bottom: 10px;
    gap: 5px;
`;

const EventUnitDescription = styled.div`
    font-weight: 500;
`;

const SessionCode = styled.div`
    font-weight: 500;
    padding-right: 5px;
`;

const SessionTime = styled.div`
    white-space: nowrap;
    padding-right: 5px;
`;

const SessionInfo = styled.div`
    color: ${(props) => props.color || "#000"};
    padding: 12px;
    font-size: ${fontSizes.xSmall};
    white-space: pre-wrap;
`;
